const authorTitlesFromCollection = (authors = []) => {
  if (authors.length <= 0) { return null; }
  if (authors.length === 1) { return authors[0].title; }
  if (authors.length === 2) { return `${authors[0].title} & ${authors[1].title}`; }

  return `${authors.slice(0, authors.length - 1).map(author => author.title).join(', ')} & ${authors[authors.length - 1].title}`;
};

export default authorTitlesFromCollection;
